module.exports = __webpack_public_path__ + "static/media/InsufficientData1.a0f78165.svg";